import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGridDataByModuleKey } from '../../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchSelectedListAndAppendToModule,
} from '../../../redux/actions';
import SelectionRemoveModal from '../../../shared/component/SelectionRemoveModal';
import { useRef } from 'react';

const CustomStatusBar = (props) => {
  const { api, context } = props;
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [rowCount, setRowCount] = useState(0);
  const [pageSize, setPageSize] = useState(null);
  const [startRow, setStartRow] = useState(1);
  const [endRow, setEndRow] = useState(pageSize);
  const moduleKey = context?.moduleKey;

  const gridData = useSelector(getGridDataByModuleKey(moduleKey));
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const fullSelection = gridDataSelection?.[moduleKey] || {};
  console.log('🚀 ~ CustomStatusBar ~ fullSelection:', fullSelection);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const pendingChangeRef = useRef(null);

  // Update page info whenever pagination changes
  useEffect(() => {
    if (gridData?.totalCount || gridData?.inputPayload) {
      const totalPages = Math.ceil(gridData?.totalCount / gridData?.inputPayload?.pageSize);
      const currentPage = gridData?.inputPayload?.pageNumber;
      const rowCount = gridData?.totalCount ? gridData?.totalCount : 0;
      const pageSize = gridData?.inputPayload?.pageSize;
      const startRow = (currentPage - 1) * pageSize + 1;
      const endRow = Math.min(startRow + pageSize - 1, rowCount);

      setTotalPages(totalPages);
      setCurrentPage(currentPage);
      setRowCount(gridData?.totalCount);
      setPageSize(pageSize);
      setStartRow(startRow);
      setEndRow(endRow);
    }
  }, [gridData]);

  useEffect(() => {
    const payload = gridData?.inputPayload;
    if (gridData?.inputPayload && Object.keys(gridData.inputPayload).length > 0) {
      let newInputPayload = {
        // ...inputPayload,
        ...payload,
        pageNumber: currentPage ? currentPage : payload.pageNumber,
        pageSize: pageSize ? pageSize : payload.pageSize,
      };
      if (JSON.stringify(payload) !== JSON.stringify(newInputPayload)) {
        dispatch(
          fetchDataAndUpdateStore({
            key: moduleKey,
            inputData: newInputPayload,
          })
        );
      }
    }
  }, [pageSize, currentPage]);
  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    const currentPageKey = `page-${currentPage}`;

    const isCurrentPageSelected =
      fullSelection && fullSelection[currentPageKey] && fullSelection[currentPageKey].length > 0;

    if (isCurrentPageSelected) {
      setShow(true); // Show confirmation modal
      pendingChangeRef.current = {
        type: 'pageSize',
        value: newSize,
      };
    } else {
      setCurrentPage(1); // Reset to page 1
      setPageSize(newSize);
    }
  };

  const handleConfirm = () => {
    setShow(false);

    dispatch(
      fetchSelectedListAndAppendToModule({
        key: moduleKey,
        selectedList: null,
      })
    );

    if (pendingChangeRef.current?.type === 'pageSize') {
      const newSize = pendingChangeRef.current.value;
      setCurrentPage(1);
      setPageSize(newSize);
      pendingChangeRef.current = null;
    }
  };

  return (
    <div style={styles.footer}>
      <span className="dsk"> Page Size:</span>{' '}
      <select onChange={handlePageSizeChange} value={pageSize}>
        {/* <option value="10">10</option> */}
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="500">500</option>
      </select>
      <p className="pageShowing">
        <span className="dsk">Showing</span>{' '}
        <strong>
          {startRow} - {endRow}
        </strong>{' '}
        of <strong>{rowCount}</strong>
      </p>
      <div style={styles.pagination} className="pagiCon">
        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
          <span className="ag-icon ag-icon-first"></span>
          <span className="dsk">First</span>
        </button>
        <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
          <span className="ag-icon ag-icon-previous"></span> <span className="dsk">Prev</span>
        </button>

        <p>
          Page {currentPage} of {totalPages}
        </p>

        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <span className="dsk">Next</span> <span className="ag-icon ag-icon-next"></span>
        </button>
        <button
          onClick={() => {
            setCurrentPage(totalPages);
          }}
          disabled={currentPage === totalPages}
        >
          <span className="dsk">Last</span> <span className="ag-icon ag-icon-last"></span>
        </button>
      </div>
      {show && (
        <SelectionRemoveModal
          show={show}
          handleClose={() => setShow(false)}
          handleConfirm={handleConfirm}
          text={'All selection will be lost, Want to Proceed?'}
        />
      )}
    </div>
  );
};

// Inline styles for the footer
const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    background: '#f8f9fa',
  },
  pagination: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
};

export default CustomStatusBar;
